import { ICONS } from '@Const/common'
import React from 'react'

const MainPreloaderOverlay = () => (
    <div className="main-preloader">
        <div className="icon-block">
            <img className="circle" src={ICONS.preloader_circle} alt="preloader" />
            <img className="logo" src={ICONS.mlc_logo} alt="preloader" />
        </div>
    </div>
)
export default MainPreloaderOverlay
